module.exports = __webpack_public_path__ + "kudos_20.svg?5e29739be9ef9104e9feaac3ec12be7a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_20.svg
// module id = 118
// module chunks = 0